import '../../assets/index14.css';var x = Object.defineProperty, k = Object.defineProperties;
var C = Object.getOwnPropertyDescriptors;
var n = Object.getOwnPropertySymbols;
var _ = Object.prototype.hasOwnProperty, b = Object.prototype.propertyIsEnumerable;
var i = (o, e, t) => e in o ? x(o, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[e] = t, m = (o, e) => {
  for (var t in e || (e = {}))
    _.call(e, t) && i(o, t, e[t]);
  if (n)
    for (var t of n(e))
      b.call(e, t) && i(o, t, e[t]);
  return o;
}, d = (o, e) => k(o, C(e));
var p = (o, e) => {
  var t = {};
  for (var r in o)
    _.call(o, r) && e.indexOf(r) < 0 && (t[r] = o[r]);
  if (o != null && n)
    for (var r of n(o))
      e.indexOf(r) < 0 && b.call(o, r) && (t[r] = o[r]);
  return t;
};
import { jsxs as f, jsx as a } from "react/jsx-runtime";
import { forwardRef as y } from "react";
import { ErrorMessage as F } from "../../molecules/ErrorMessage/index.js";
import { Label as I } from "../Label/index.js";
import { C as v, G as N } from "../../index-Df5OAx-u.js";
import { CheckFarFAIcon as g } from "../Icons/index.js";
const j = "Checkbox-module__container___FFDwI", w = "Checkbox-module__root___0NvcV", E = "Checkbox-module__body___iat8w", G = "Checkbox-module__input___FPIR1", R = "Checkbox-module__label___kt2po", c = {
  container: j,
  root: w,
  body: E,
  input: G,
  label: R
}, A = ({ className: o }) => /* @__PURE__ */ a(g, { className: o }), u = y((B, h) => {
  var s = B, {
    error: o,
    mod: e,
    label: t
  } = s, r = p(s, [
    "error",
    "mod",
    "label"
  ]);
  const l = !!o || void 0;
  return /* @__PURE__ */ f("div", { className: c.container, children: [
    /* @__PURE__ */ a(
      v,
      d(m({}, r), {
        "aria-invalid": l,
        classNames: {
          root: c.root,
          body: c.body,
          input: c.input,
          label: c.label
        },
        mod: { error: l },
        ref: h,
        label: /* @__PURE__ */ a(I, { label: String(t) }),
        icon: A
      })
    ),
    o && /* @__PURE__ */ a(F, { error: o })
  ] });
});
u.displayName = "Checkbox";
const $ = Object.assign(u, { Group: N });
export {
  $ as Checkbox,
  u as Item
};
